import { render, staticRenderFns } from "./uet.vue?vue&type=template&id=56c5eb2d&scoped=true&"
import script from "./uet.vue?vue&type=script&lang=js&"
export * from "./uet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5eb2d",
  null
  
)

export default component.exports